import { Show } from "solid-js";
import { Dynamic } from "solid-js/web";

export function Provider(props) {
  const accountLabel = () => {
    if (!props.account) return null;

    return props.account.email || props.account.displayName || "Connected";
  };

  return (
    <li class="list-row items-center">
      <div>
        <Dynamic component={props.provider.Icon} />
      </div>
      <div class="list-col-grow min-w-0">
        <div>{props.provider.name}</div>
        <Show when={accountLabel()}>
          <div class="text-xs opacity-60 truncate">{accountLabel()}</div>
        </Show>
      </div>
      <div class="justify-self-end">
        <Dynamic component={props.button} />
      </div>
    </li>
  );
}
